var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiveMoneyQuicklyBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 65,
    viewBox: "0 0 70 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.917)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F1",
    cx: 32.083,
    cy: 32.083,
    r: 32.083
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.083 0v64.167c17.72 0 32.084-14.365 32.084-32.084C64.167 14.365 49.802 0 32.083 0z",
    fill: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.667 8.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FF0008",
    cx: 23.333,
    cy: 23.333,
    r: 23.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.333c0 12.87 10.464 23.334 23.333 23.334V0C10.463 0 0 10.464 0 23.333z",
    fill: "#FF4C52"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.516 19.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.484 6.854c4.084 0 6.927-1.786 6.927-3.427 0-1.64-2.843-3.427-6.927-3.427-4.083 0-6.927 1.823-6.927 3.427s2.844 3.427 6.927 3.427zM18.448 21.146c-2.734 0-5.14-.693-6.745-1.823-.11.255-.219.474-.219.73 0 1.603 2.844 3.39 6.927 3.39 1.605 0 2.99-.256 4.084-.693-.474-.583-.839-1.203-1.167-1.86-.875.183-1.86.256-2.88.256zM18.411 12.87c-2.697 0-5.067-.693-6.671-1.823-.11.255-.22.474-.22.729 0 1.604 2.808 3.39 6.855 3.39.839 0 1.64-.109 2.333-.218a9.53 9.53 0 0 1 .985-2.443 14.8 14.8 0 0 1-3.282.365z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.484 10.938c4.084 0 6.927-1.787 6.927-3.391 0-.255-.072-.474-.218-.73-1.604 1.13-4.01 1.824-6.709 1.824-2.734 0-5.104-.693-6.708-1.823-.11.255-.219.474-.219.729 0 1.604 2.844 3.39 6.927 3.39zM20.49 16.917c-.657.109-1.386.145-2.115.145-2.698 0-5.104-.692-6.708-1.822-.11.255-.22.474-.22.729 0 1.604 2.845 3.39 6.892 3.39.838 0 1.604-.073 2.296-.218a9.05 9.05 0 0 1-.218-1.97c.073-.108.073-.181.073-.254z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 29.714,
    cy: 17.099,
    r: 7.292
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.081 15.393a1.708 1.708 0 0 0-1.208-.534.73.73 0 0 0-.574.147.625.625 0 0 0-.248.514c0 1.015 2.921.935 2.921 2.971.042 1.002-.69 1.89-1.726 2.057v1.108h-1.078v-1.068a3.743 3.743 0 0 1-1.934-.815l.691-1.055c.442.367.995.588 1.575.621a.79.79 0 0 0 .642-.153.707.707 0 0 0 .262-.588c-.006-1.102-2.928-1.082-2.928-2.985-.069-.988.67-1.856 1.678-2.003v-1.068h1.07v1.068c.643.094 1.23.4 1.658.881l-.8.902z",
    fill: "#FF0008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.953 13.927H3.72c-.365 0-.62-.292-.62-.656 0-.365.292-.656.62-.656h6.307M10.026 21.948H2.37c-.365 0-.62-.292-.62-.656 0-.365.292-.657.62-.657h7.656M10.026 17.938H.62c-.328 0-.62-.256-.62-.657 0-.4.292-.656.62-.656h9.406",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveMoneyQuicklyBadge);
export default __webpack_public_path__ + "static/media/receive-money-quickly-badge.d3e3220b791962371cbc4ee55f469ec0.svg";
export { ForwardRef as ReactComponent };